<template>
  <div class="row">
    <div class="col-12">
      <input type="text"
             v-model="paramsContratista.filtro"
             id="filtro-contratistas"
             class="form-control"
             placeholder="Buscar generales"
             :disabled="loading"
             @keyup="filtrarContratistas()"
      />
      <b-form-checkbox v-model="paramsContratista.asignadas"
                       class="pull-left"
                       @change="filtrarContratistas()"
      >
        Solo empresas asignadas
      </b-form-checkbox>
      <p class="mt-0 mb-2 small text-right text-muted">
        {{ contratistas_filtrados.contratistas.length }} empresas encontradas
      </p>
    </div>
    <div class="col-12 mt-2">
      <b-table :items="contratistas_filtrados.contratistas"
               :fields="columnas"
               :per-page="cantidad"
               :current-page="pagina_actual"
               striped
               hover
      >
        <template v-slot:cell(checked)="row"
                  class="text-center"
        >
          <b-form-checkbox :disabled="selectedEmpresa.id === row.item.id || !validarPermisoComponente('empresa-editar-contratistas')"
                           v-model="row.item.checked"
                           @change="_asignarContratistas(row.item)"
          />
        </template>
        <template v-slot:cell(logo)="row"
                  class="text-center"
        >
          <b-form-checkbox :disabled="!row.item.checked || !validarPermisoComponente('empresa-editar-contratistas')"
                           v-model="row.item.permitir_logo_etiquetas"
                           v-b-popover.hover.top="'Permite al contratista generar etiquetas con logo propio'"
                           title="Logo etiquetas"
                           @change="_asignarContratistas(row.item)"
          />
        </template>
      </b-table>

      <b-row>
        <b-col>
          <b-button @click="backRoute()"
                    size="sm"
                    variant="secondary"
                    class="float-left"
          >
            <i class="fa fa-reply fa-lg"></i>
            Volver
          </b-button>
          <el-pagination v-if="contratistas_filtrados.contratistas && !!contratistas_filtrados.contratistas.length"
                         v-model="pagina_actual"
                         @size-change="filtrarContratistas()"
                         @current-change="filtrarContratistas()"
                         :current-page.sync="pagina_actual"
                         class="float-right"
                         :page-size.sync="cantidad"
                         :page-sizes="[10, 30, 50, 100]"
                         layout="total, sizes, prev, pager, next"
                         :total="contratistas_filtrados.contratistas.length"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import { validarPermisoComponente } from "@/plugins/acl";

export default {
  name: 'Contratistas',
  data() {
    return {
      pagina_actual: 1,
      cantidad: 20,
      columnas: [
        {
          key: 'nombre',
          label: 'Empresa',
          sortable: true,
          thClass: 'table-active'
        },
        {
          key: 'checked',
          label: 'Asignado',
          sortable: false,
          tdClass: 'text-center',
          thClass: 'text-center table-active',
          thStyle: {width: '100px'},
        },
        {
          key: 'logo',
          label: 'Logo etiquetas',
          sortable: false,
          tdClass: 'text-center',
          thClass: 'text-center table-active',
          thStyle: {width: '100px'},
        },
      ],
      validarPermisoComponente: validarPermisoComponente,
    };
  },
  computed: {
    ...mapState('empresa', [
      'contratistas',
      'contratistas_filtrados',
      'selectedEmpresa',
      'paramsContratista',
    ]),
    ...mapGetters('empresa', ['getContratistas']),
    ...mapState('dashboard', ['loading']),
  },
  async mounted() {
    await this.listarContratistas();
  },
  methods: {
    ...mapMutations('dashboard', ['load']),
    ...mapActions('empresa', ['asignarContratistas', 'filtrarContratistas', 'listarContratistas']),
    ...mapMutations('empresa', ['resetParamsContratista']),
    async _asignarContratistas(contratista) {
      await this.asignarContratistas(contratista);
    },
    backRoute(){
        const currentPath = this.$route.path;
        if (currentPath.includes("/my-company")) {
            this.$router.go(-1);
        }else {
            this.$router.push("/empresas");
        }
    },
  },
};
</script>

<style scoped></style>
